import { makeVar } from "@apollo/client";

import {
  RosterManagementLeagueFragment,
  RosterManagementNationalityFragment,
} from "@/generated/graphql";

export const DEFAULT_MIN_AGE = 18;
export const DEFAULT_MAX_AGE = 30;

export const DEFAULT_MIN_COST = 10000;
export const DEFAULT_MAX_COST = 20000000;

export const DEFAULT_MIN_MONTHS_REMAINING = 0;
export const DEFAULT_MAX_MONTHS_REMAINING = 60;

export const DEFAULT_MIN_MINUTES_PLAYED = 0;
export const DEFAULT_MAX_MINUTES_PLAYED = 5000;

export const MIN_AGE = 15;
export const MAX_AGE = 50;

export const MIN_COST = 0;
export const MAX_COST = 100000000;

export const MIN_MONTHS_REMAINING = 0;
export const MAX_MONTHS_REMAINING = 60;

export const MIN_MINUTES_PLAYED = 0;
export const MAX_MINUTES_PLAYED = 5000;

/**
 *
 */
export interface IFilterOption {
  name: string;
  id: string;
}

/**
 *
 */
export interface IFilterValues {
  leagues?: RosterManagementLeagueFragment[] | null;
  nationalities?: RosterManagementNationalityFragment[] | null;
  maxAge?: number | null;
  minAge?: number | null;
  minSalary?: number | null;
  maxSalary?: number | null;
  minMonthsRemaining?: number | null;
  maxMonthsRemaining?: number | null;
}

export const filterValuesVar = makeVar<IFilterValues | null>(null);
